import React from "react";
import { motion } from "framer-motion";
import { FadeUp, SectionLabel } from "./Motion";
import { useContent, resolveImg } from "../context/ContentContext";

const Team = () => {
  const { team } = useContent();
  return (
    <section id="team" className="relative py-28 md:py-40 bg-[#FAFAFA]" data-testid="team-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <FadeUp><SectionLabel num="02">The Team</SectionLabel></FadeUp>
        <div className="mt-8 md:mt-12 grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
          <FadeUp delay={0.05} className="md:col-span-12">
            <h2 className="font-display text-3xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-[-0.02em] text-black">
              People who believe — <br />
              <span className="font-semibold">before policies are written.</span>
            </h2>
          </FadeUp>
        </div>

        <div className="mt-16 md:mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {team.map((m, idx) => (
            <motion.article
              key={m.id || m.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, delay: idx * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="group"
              data-testid={`team-card-${idx}`}
            >
              <div className="relative overflow-hidden rounded-3xl bg-zinc-100 aspect-[4/5]">
                {m.img && (
                  <img src={resolveImg(m.img)} alt={m.name}
                    className={`absolute inset-0 w-full h-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-[1.04] ${m.grayscale ? "grayscale" : ""}`}
                    loading="lazy" />
                )}
                <div className="absolute top-4 left-4 text-[10px] uppercase tracking-[0.28em] text-white/90 mix-blend-difference">
                  0{idx + 1}
                </div>
              </div>
              <div className="mt-5 flex items-start justify-between gap-4">
                <div>
                  <h3 className="font-display text-xl md:text-2xl font-medium text-black tracking-tight">{m.name}</h3>
                  <p className="text-sm text-zinc-500 mt-1">{m.title}</p>
                </div>
              </div>
              <ul className="mt-5 space-y-2.5 border-t border-black/10 pt-5">
                {(m.achievements || []).map((a, i) => (
                  <li key={i} className="flex items-start gap-3 text-sm text-zinc-700" data-testid={`team-${idx}-achievement-${i}`}>
                    <span className="mt-2 h-px w-3 bg-black flex-none" />
                    <span>{a}</span>
                  </li>
                ))}
              </ul>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
